var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'flex justify-end' : _vm.isJustifiedToRight}},[_c('Link',{attrs:{"text":_vm.$t('Learn more'),"url":_vm.link,"type":_vm.LinkType.Primary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }